import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { usePaymentPlanForm } from '@/features/student-management/hooks/usePaymentPlanForm';
import { PaymentPlanForm } from '@/features/student-management/ui/organisms/PaymentPlanForm';
import { PaymentPlanEditTemplate } from '@/features/student-management/ui/templates/PaymentPlanEditTemplate';

export const Route = createFileRoute('/_authenticated/persons/payments/plans/$planId/')({
  component: PaymentPlanEditPage,
});

function PaymentPlanEditPage() {
  const { planId } = Route.useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('personManagement');
  const numericId = planId === 'new' ? undefined : Number(planId);
  const { isEditing } = usePaymentPlanForm(numericId);

  const title = isEditing ? t('planForm.title.edit') : t('planForm.title.create');

  return (
    <PaymentPlanEditTemplate title={title}>
      <PaymentPlanForm
        planId={numericId}
        onCancel={() => void navigate({ to: '/persons/payments' })}
        onSaved={() => void navigate({ to: '/persons/payments' })}
      />
    </PaymentPlanEditTemplate>
  );
}
